import gameState, {
    updateGameResultRecordsCount
} from 'client/game_checkIn/redux/modules/gameState';

export default {
    gameState
};

export function init(dispatch) {
    return dispatch(updateGameResultRecordsCount());
}
